module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_8023.0024c50f.png";